import gql from 'graphql-tag';

const postGuaranteeForceMutation = gql`
  mutation PostGuaranteeForce($input: PostGuaranteeForceInput!) {
    postGuaranteeForce(input: $input) {
      success
      errors
      forceGuaranteeResult {
        status
      }
    }
  }
`;

export default postGuaranteeForceMutation;
